import { render, staticRenderFns } from "./EmptyRecords.vue?vue&type=template&id=37589678&scoped=true&"
import script from "./EmptyRecords.vue?vue&type=script&lang=js&"
export * from "./EmptyRecords.vue?vue&type=script&lang=js&"
import style0 from "./EmptyRecords.vue?vue&type=style&index=0&id=37589678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37589678",
  null
  
)

export default component.exports